import React, {useEffect, useState} from 'react';
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import {useDashboard} from "../../utilities/context/dashboard/dashboard-context";
import {usePurchase} from "../../utilities/context/purchase/purchase-context";
import useAuthCalls from "../../utilities/custom-hooks/auth-calls";
import {doPostAddonsIntentRequest} from "../../logic/users";
import CheckoutForm from "../../components/Payments/CheckoutForm";
import Loading from "../../components/UI/Loading";
import ErrorMessage from "../../components/UI/ErrorMessage";
import PurchaseRecap from "../../components/Dashboard/User/PurchaseRecap";
import BackToDashboard from "../../components/Dashboard/BackToDashboard";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

const TransactionPage = () => {

    const {user_id} = useDashboard();
    const {selectedSubscription, selectedAddons, setAmount} = usePurchase();

    const {call} = useAuthCalls();

    const [loading,setLoading] = useState(false);
    const [clientSecret, setClientSecret] = useState("");
    const [errorIntent, setErrorIntent] = useState(false);

    useEffect(() => {
        // load selected subscription or addons
        const load = async () => {
            setLoading(true);
            await call(
                () => doPostAddonsIntentRequest(user_id, selectedAddons.map((addon) => addon.id)),
                (res) => {
                    if (res.client_secret && res.status === "ok") {
                        setClientSecret(res.client_secret);
                    }
                    if (res.amount !== null) {
                        let num = res.amount / 100;
                        num > 0 && setAmount(parseFloat(num).toFixed(2));
                    }
                },
                (error) => {
                    setErrorIntent(true);
                }
            );
            setLoading(false);
        }

        load();

        // load stripe

        //if there are errors show message
    }, []);

    const options = {
        clientSecret
    }

    return (
        <div className="flex flex-col items-center w-full py-4" style={{maxWidth: "1200px"}}>
            <div className="w-full text-left">
                <BackToDashboard />
            </div>

            <PurchaseRecap loading={loading}/>
            {loading
                ? <Loading/>
                : <div>
                    {errorIntent &&
                    <ErrorMessage>Qualcosa è andato storto. Impossibile procedere.</ErrorMessage>
                    }
                    {clientSecret &&
                    <Elements stripe={stripePromise} options={options}>
                        <div className="bg-gray-100 flex flex-col items-center p-4 text-black rounded-lg">
                            <CheckoutForm />
                        </div>
                    </Elements>}
                </div>
            }
        </div>
    );
};

export default TransactionPage;